//验证手机号
export function validateTel(mobile) {
  return /^1[2-9]\d{9}$/.test(mobile);
}

//验证验证码
export function validateAuthcode(authCode) {
  return /^\d{6}$/.test(authCode);
}

//截取数字字符串
export function replaceNumber(str, maxLength) {
  return str.substr(0, maxLength);
}

//验证身份证号
export function validateIdcard(text) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/.test(text);
}

//验证姓名
export function validateName(text) {
  return /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/.test(text);
}

//验证图形验证码
export function validateImgcode(imgCode) {
  return /^[a-zA-Z0-9]{4}$/.test(imgCode);
}

// 隐藏手机号中间4位
export function replaceTel(telNum) {
  return telNum.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

//姓名脱敏
export function replaceName(str) {
  if (str) {
    if(str.length <= 3){
      return "*" + str.substring(1, str.length);
    } else if(str.length > 3 && str.length <= 6){
      return "**" + str.substring(2, str.length);
    } else if(str.length > 6){
      return str.substring(0, 2) + "****" + str.substring(6, str.length)
    }
  } else {
    return '';
  }
}

//判断密码是否是连续相同的
export function samePassword(pwd) {
  return /^(\d)\1+$/.test(pwd);
}